/* eslint-disable no-return-assign */
import React, { useEffect, useRef } from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getTransformedId } from "@qlik/qlik/src/lib/util/format";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { handleKeyboardEventBehavior } from "@qlik/qlik/src/lib/util/helpers";
import RichText from "@qlik/qlik/src/components/RichText";

import * as styles from "./styles.module.css";

const Accordion = ({ data }) => {
    const { title, body, additionalConfiguration, customId, id, backgroundColor, cardItems = [] } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const accordionRefs = useRef([]);
    const toggleAccordion = (index) => {
        const accordionItem = accordionRefs.current[index];
        accordionItem.classList.toggle(styles.active);
    };

    useEffect(() => {
        accordionRefs.current[0].classList.add(styles.active);
    }, []);

    return (
        <section
            className={`${sectionSpacingClassName} ${sectionColorMapping.bgColor} xl:px-[135px] scroll-mt-15`}
            data-section
            id={customId ?? id}
        >
            <div className="container lg:px-15">
                {(title || body?.raw) && (
                    <div className=" mb-7.5 md:mb-15">
                        {title && (
                            <h2 className="md:text-6xl font-semibold leading-tight tracking-tight10 text-center ">
                                {title}
                            </h2>
                        )}
                        {body?.raw && <RichText data={data} className={`${styles.bodyContent}`} />}
                    </div>
                )}

                {cardItems?.map((cardItem, index) => (
                    <div
                        className={`${styles.accordion} rounded bg-white  box-border`}
                        key={cardItem?.title}
                        ref={(el) => {
                            accordionRefs.current[index] = el;
                        }}
                    >
                        <div
                            className={`px-7.5 py-5  after:dropdown-icon-lg relative cursor-pointer inline-block w-full	text-gray  md:text-2xl font-normal leading-relaxed tracking-tight6   ${styles.accordionTitle}`}
                            role="button"
                            onClick={() => toggleAccordion(index)}
                            tabIndex={-1}
                            onKeyDown={(e) => {
                                handleKeyboardEventBehavior(e, () => toggleAccordion(index));
                            }}
                        >
                            <span className="inline-block pr-15"> {cardItem?.title}</span>
                        </div>

                        <div className={`${styles.bodySection} `}>
                            {cardItem?.body && <RichText data={cardItem} className="px-7.5 pb-7.5 mt-2.5" />}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Accordion;
